import { SUN, MOON } from '../shapePaths';
import { SUN_BODY, MOON_BODY } from '../shapeBodies';
import { blend } from '../tint';

interface Props {
  sunOpacity: number;
  moonOpacity: number;
  skyColor: string;
}

export function SunMoonLayer({ sunOpacity, moonOpacity, skyColor }: Props) {
  const sunBody = blend('#F5B800', skyColor, 0.15);
  const moonBody = blend('#E8B923', skyColor, 0.25);
  return (
    <div className="layer" style={{ zIndex: 15 }}>
      {sunOpacity > 0 && (
        <svg
          viewBox={SUN.viewBox}
          aria-label="Sun"
          style={{
            position: 'absolute',
            top: '8%',
            right: '12%',
            width: 'clamp(80px, 12vw, 160px)',
            height: 'auto',
            opacity: sunOpacity,
            transition: 'opacity 2s ease-in-out',
          }}
        >
          <path
            d={SUN_BODY.d}
            fill={sunBody}
            fillRule={SUN_BODY.fillRule}
            style={{ transition: 'fill 4s ease-in-out' }}
          />
          <path d={SUN.d} fill="#F5B800" fillRule={SUN.fillRule} />
        </svg>
      )}
      {moonOpacity > 0 && (
        <svg
          viewBox={MOON.viewBox}
          aria-label="Moon"
          style={{
            position: 'absolute',
            top: '8%',
            right: '14%',
            width: 'clamp(60px, 8vw, 110px)',
            height: 'auto',
            opacity: moonOpacity,
            transition: 'opacity 2s ease-in-out',
          }}
        >
          <path
            d={MOON_BODY.d}
            fill={moonBody}
            fillRule={MOON_BODY.fillRule}
            style={{ transition: 'fill 4s ease-in-out' }}
          />
          <path
            d={MOON.d}
            fill="#E8B923"
            fillRule={MOON.fillRule}
            transform={MOON.transform}
          />
        </svg>
      )}
    </div>
  );
}
